import React from "react";
import { FileText, Plane, Armchair, MousePointerClick } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useI18n } from "@/i18n";

const ICONS = [<FileText size={22} />, <Plane size={22} />, <Armchair size={22} />, <MousePointerClick size={22} />];

export function Solution() {
  const { t } = useI18n();
  const s = t.solution;
  return (
    <section id="solution" className="bg-midnight text-white py-24 md:py-32 grain">
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <p className="overline text-champagne">{s.overline}</p>
          <h2 className="mt-4 font-serif text-4xl md:text-6xl tracking-tight max-w-3xl leading-[1.02]">{s.title}</h2>
          <p className="mt-6 max-w-2xl text-white/60 text-base md:text-lg">{s.sub}</p>
        </Reveal>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {s.cards.map((c, i) => (
            <Reveal key={i} delay={i * 0.08} className="bg-midnight">
              <div className="h-full p-8" data-testid={`solution-card-${i}`}>
                <span className="grid place-items-center h-12 w-12 rounded-full bg-pine text-cream">{ICONS[i]}</span>
                <h3 className="mt-6 font-serif text-2xl">{c.t}</h3>
                <p className="mt-3 text-white/55 text-sm leading-relaxed">{c.d}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-14 text-center font-serif text-2xl md:text-4xl tracking-tight text-cream" data-testid="solution-tagline">
            {s.tagline}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
